import React, { Component } from "react";
import Table from "components/Table/Table.js";
import Button from "components/CustomButtons/Button.js";
import axios from "axios";
import { Link } from "react-router-dom";
import Assignment from "@material-ui/icons/Assignment";
import GridContainer from "components/Grid/GridContainer.js";
import GridItem from "components/Grid/GridItem.js";
import Card from "components/Card/Card.js";
import CardHeader from "components/Card/CardHeader.js";
import CardIcon from "components/Card/CardIcon.js";
import CardBody from "components/Card/CardBody.js";
import AddAlert from "@material-ui/icons/AddAlert";
import SnackbarContent from "components/Snackbar/SnackbarContent.js";
import InputLabel from "@material-ui/core/InputLabel";
import FormControl from "@material-ui/core/FormControl";
import { makeStyles } from "@material-ui/core/styles";
import Select from "@material-ui/core/Select";
import MenuItem from "@material-ui/core/MenuItem";
import styles from "assets/jss/material-dashboard-pro-react/customSelectStyle.js";
import Loader from "components/Loader";
import Modal from "react-awesome-modal";
import Constants from "variables/Constants";
import { MultiSelect } from "react-multi-select-component";
import renderHTML from "react-render-html";
import { IconButton } from "@material-ui/core";
import Notification from "components/Notification";
const classes = makeStyles(styles);
const perPages = ["10", "25", "50", "100", "200", "300", "500"];
export default class FaceToFaceBatchStudents extends Component {
  state = {
    visible: false,
    isReporting: false,
    notifyDelete: false,
    delLoading: false,
    rowId: 0,
    notifyStatus: false,
    secondaryCategories: [],
    batch_id: "",
    isRefreshing: false,
    // Optional date range for the "Regenerate report" calculation. Both empty
    // = all days; both set = scope the progress calc to that range.
    reportStartDate: "",
    reportEndDate: "",

    type: "success",
    message: "",
    notification: false,

    active: 1,
    per_page: "10",
    currentPage: 1,
    prevPage: 0,
    nextPage: 0,
    lastPage: 0,
    lastPageView: false,
    firstPageView: false,
    total: 0,
    from: 0,
    to: 0,
    fromInc: 1,
    toInc: 5,
    btnIdArray: [],
    filteredBtnIdArray: [],
    search: "",
    // Filters — applied together (combine, never reset each other). Empty string
    // means "not applied" and that key is omitted from the request entirely.
    user_type: "",
    attempt_id: "",
    status: "",
    performance: "",
    attemptsList: [],
    visibleTestSeries: false,
    allotedTestSeries: [],
    notallotedTestSeries: [],
    testSeries: [],
    test: [],
    test_seriesId: [],
    fToFBatchId: "",
    userId: "",
    notifyTest: false,
    notifyMessage: "",

    reportVisible: false,

    downloadLoading: false,
    notifyDownload: false,
    pdfDownloading: false,
  };
  componentDidMount() {
    this.setState(
      {
        batch_id: window.location.pathname.split("/")[3],
        fromInc: 1,
        active: 1,
        toInc: 5,
      },
      () => {
        this.getAttempts();
        this.getallUsers();
      },
    );
  }

  onClose = () => {
    this.setState({
      isReporting: false,
      reportStartDate: "",
      reportEndDate: "",
    });
  };

  // Attempts list for the Attempt filter dropdown. Only ACTIVE attempts are
  // shown (a missing status is treated as active, so the dropdown never blanks
  // out if the API omits the field).
  getAttempts = () => {
    axios
      .get(Constants.getUrls.attempt)
      .then((resp) => {
        const items = Array.isArray(resp.data)
          ? resp.data
          : resp.data?.data || [];
        const activeItems = items.filter(
          (a) => String(a.status || "ACTIVE").toUpperCase() === "ACTIVE",
        );
        this.setState({ attemptsList: activeItems });
      })
      .catch((err) => console.error("Failed to load attempts", err));
  };

  // The filter portion shared by the students list AND the PDF preview, so the
  // two can never drift. `search` is always included (may be empty); the rest
  // only when set. NOTE: pagination (per_page/page) is intentionally excluded —
  // the PDF must reflect the full filtered set, not just the current page.
  buildFilterQuery = () => {
    const parts = ["search=" + encodeURIComponent(this.state.search || "")];
    if (this.state.user_type)
      parts.push("user_type=" + encodeURIComponent(this.state.user_type));
    if (this.state.attempt_id)
      parts.push("attempt_id=" + encodeURIComponent(this.state.attempt_id));
    if (this.state.status)
      parts.push("status=" + encodeURIComponent(this.state.status));
    if (this.state.performance)
      parts.push("performance=" + encodeURIComponent(this.state.performance));
    return parts.join("&");
  };

  // Single source of truth for the students request URL. Search + every active
  // filter are appended TOGETHER, and a filter key is only added when it has a
  // value — so selecting status, then type, then attempt keeps all three (they
  // combine, never reset one another), and unselected keys are never sent.
  buildStudentsUrl = ({ page } = {}) => {
    let url =
      Constants.getUrls.getFaceBatchStudents +
      "?ftof_batch_id=" +
      this.state.batch_id +
      "&" +
      this.buildFilterQuery();
    if (this.state.per_page) url += "&per_page=" + this.state.per_page;
    if (page) url += "&page=" + page;
    return url;
  };

  // Canonical loader used by search, filters, per-page and (page 1) reloads.
  loadStudents = (page = 1) => {
    axios.get(this.buildStudentsUrl({ page })).then((resp) => {
      let btnIdArray = [];
      for (let i = 1; i <= resp.data.last_page; i++) {
        btnIdArray.push(i);
      }
      this.setState(
        {
          btnIdArray,
          active: page,
          secondaryCategories: resp.data.data,
          total: resp.data.total,
          from: resp.data.from,
          to: resp.data.to,
        },
        () => {
          let filteredBtnIdArray = this.state.btnIdArray.filter(
            (v) => v >= this.state.fromInc && v <= this.state.toInc,
          );
          this.setState({ filteredBtnIdArray });
        },
      );
    });
  };

  // Re-run the query with current search + filters, jumping back to page 1.
  applyFilters = () => {
    this.setState({ fromInc: 1, toInc: 5, active: 1 }, () =>
      this.loadStudents(1),
    );
  };

  // A dropdown changed: set just that one key and reload — the other selected
  // filters are preserved because buildStudentsUrl reads them all from state.
  handleFilterChange = (e) => {
    this.setState({ [e.target.name]: e.target.value }, () =>
      this.applyFilters(),
    );
  };

  // Reset search + all filters (no full page reload).
  clearFilters = () => {
    this.setState(
      {
        search: "",
        user_type: "",
        attempt_id: "",
        status: "",
        performance: "",
        fromInc: 1,
        toInc: 5,
        active: 1,
      },
      () => this.loadStudents(1),
    );
  };

  getallUsers = () => {
    this.clearFilters();
  };

  searchUser = () => {
    this.applyFilters();
  };

  refreshReport = () => {
    const { reportStartDate, reportEndDate } = this.state;

    // Both dates are optional, but if one is set the other must be too
    // (mirrors the backend validation).
    if (
      (reportStartDate && !reportEndDate) ||
      (!reportStartDate && reportEndDate)
    ) {
      this.setState({
        notification: true,
        type: "error",
        message: "Select both start and end dates, or leave both empty.",
      });
      setTimeout(() => this.setState({ notification: false }), 2500);
      return;
    }
    if (reportStartDate && reportEndDate && reportStartDate > reportEndDate) {
      this.setState({
        notification: true,
        type: "error",
        message: "Start date cannot be after end date.",
      });
      setTimeout(() => this.setState({ notification: false }), 2500);
      return;
    }

    const payload = {};
    if (reportStartDate && reportEndDate) {
      payload.start_date = reportStartDate;
      payload.end_date = reportEndDate;
    }

    this.setState({ isRefreshing: true });
    axios
      .post(
        `https://admin.akclasses.in/api/batch/${this.state.batch_id}/progress/store`,
        payload,
      )
      .then((resp) => {
        console.log("Refresh Report Response:", resp);
        this.setState({
          notification: true,
          type: "success",
          message: resp?.data.message,
          loading: false,
        });
        setTimeout(() => {
          this.setState({ notification: false });
        }, 2000);
        this.getBatchStudents();
        this.setState({
          isReporting: false,
        });
      })
      .catch((err) => {
        console.error("Failed to refresh report", err);
        this.setState({
          notification: true,
          type: "error",
          message: "Something went wrong. Please try again.",
          isRefreshing: false,
        });
      })
      .finally(() => {
        this.setState({ isRefreshing: false, isReporting: false });
      });
  };

  getColor = (value) => {
    if (value < 50) return "red";
    if (value >= 50 && value <= 75) return "orange";
    return "green";
  };

  handlePage = (e) => {
    // Change per-page, then reload page 1 keeping search + all active filters.
    this.setState(
      {
        [e.target.name]: e.target.value,
        fromInc: 1,
        active: 1,
        toInc: 5,
      },
      () => {
        this.loadStudents(1);
      },
    );
  };

  currentPage = (v) => {
    // Page navigation keeps search + all active filters via buildStudentsUrl.
    axios.get(this.buildStudentsUrl({ page: v })).then((resp) => {
      this.setState({
        total: resp.data.total,
        from: resp.data.from,
        to: resp.data.to,
        secondaryCategories: resp.data.data,
        operatinalCategories: resp.data.data,
        active: v,
      });
    });
  };

  prevPages = () => {
    this.setState(
      {
        fromInc: this.state.fromInc - 5,
        toInc: this.state.toInc - 5,
      },
      () => {
        let filteredBtnIdArray = this.state.btnIdArray.filter(
          (v) => v >= this.state.fromInc && v <= this.state.toInc,
        );
        if (filteredBtnIdArray.length >= 1) {
          if (filteredBtnIdArray.length === 1) {
            this.setState(
              {
                fromInc: this.state.fromInc + 4,
                toInc: this.state.toInc + 4,
              },
              () => {
                let filteredBtnIdArray = this.state.btnIdArray.filter(
                  (v) => v >= this.state.fromInc && v <= this.state.toInc,
                );
                this.setState({ filteredBtnIdArray });
              },
            );
          } else if (filteredBtnIdArray.length === 2) {
            this.setState(
              {
                fromInc: this.state.fromInc + 3,
                toInc: this.state.toInc + 3,
              },
              () => {
                let filteredBtnIdArray = this.state.btnIdArray.filter(
                  (v) => v >= this.state.fromInc && v <= this.state.toInc,
                );
                this.setState({ filteredBtnIdArray });
              },
            );
          } else if (filteredBtnIdArray.length === 3) {
            this.setState(
              {
                fromInc: this.state.fromInc + 2,
                toInc: this.state.toInc + 2,
              },
              () => {
                let filteredBtnIdArray = this.state.btnIdArray.filter(
                  (v) => v >= this.state.fromInc && v <= this.state.toInc,
                );
                this.setState({ filteredBtnIdArray });
              },
            );
          } else if (filteredBtnIdArray.length === 4) {
            this.setState(
              {
                fromInc: this.state.fromInc + 1,
                toInc: this.state.toInc + 1,
              },
              () => {
                let filteredBtnIdArray = this.state.btnIdArray.filter(
                  (v) => v >= this.state.fromInc && v <= this.state.toInc,
                );
                this.setState({ filteredBtnIdArray });
              },
            );
          } else {
            this.setState({ filteredBtnIdArray });
          }
        } else {
          this.setState(
            {
              fromInc: this.state.fromInc + 5,
              toInc: this.state.toInc + 5,
            },
            () => {
              let filteredBtnIdArray = this.state.btnIdArray.filter(
                (v) => v >= this.state.fromInc && v <= this.state.toInc,
              );
              this.setState({ filteredBtnIdArray });
            },
          );
        }
      },
    );
  };

  nextPages = () => {
    this.setState(
      {
        fromInc: this.state.fromInc + 5,
        toInc: this.state.toInc + 5,
      },
      () => {
        let filteredBtnIdArray = this.state.btnIdArray.filter(
          (v) => v >= this.state.fromInc && v <= this.state.toInc,
        );
        if (filteredBtnIdArray.length >= 1) {
          if (filteredBtnIdArray.length === 1) {
            this.setState(
              {
                fromInc: this.state.fromInc - 4,
                toInc: this.state.toInc - 4,
              },
              () => {
                let filteredBtnIdArray = this.state.btnIdArray.filter(
                  (v) => v >= this.state.fromInc && v <= this.state.toInc,
                );
                this.setState({ filteredBtnIdArray });
              },
            );
          } else if (filteredBtnIdArray.length === 2) {
            this.setState(
              {
                fromInc: this.state.fromInc - 3,
                toInc: this.state.toInc - 3,
              },
              () => {
                let filteredBtnIdArray = this.state.btnIdArray.filter(
                  (v) => v >= this.state.fromInc && v <= this.state.toInc,
                );
                this.setState({ filteredBtnIdArray });
              },
            );
          } else if (filteredBtnIdArray.length === 3) {
            this.setState(
              {
                fromInc: this.state.fromInc - 2,
                toInc: this.state.toInc - 2,
              },
              () => {
                let filteredBtnIdArray = this.state.btnIdArray.filter(
                  (v) => v >= this.state.fromInc && v <= this.state.toInc,
                );
                this.setState({ filteredBtnIdArray });
              },
            );
          } else if (filteredBtnIdArray.length === 4) {
            this.setState(
              {
                fromInc: this.state.fromInc - 1,
                toInc: this.state.toInc - 1,
              },
              () => {
                let filteredBtnIdArray = this.state.btnIdArray.filter(
                  (v) => v >= this.state.fromInc && v <= this.state.toInc,
                );
                this.setState({ filteredBtnIdArray });
              },
            );
          } else {
            this.setState({ filteredBtnIdArray });
          }
        } else {
          this.setState(
            {
              fromInc: this.state.fromInc - 5,
              toInc: this.state.toInc - 5,
            },
            () => {
              let filteredBtnIdArray = this.state.btnIdArray.filter(
                (v) => v >= this.state.fromInc && v <= this.state.toInc,
              );
              this.setState({ filteredBtnIdArray });
            },
          );
        }
      },
    );
  };

  getBatchStudents = () => {
    axios
      .get(
        Constants.getUrls.getFaceBatchStudents +
          "?ftof_batch_id=" +
          this.state.batch_id,
      )
      .then((resp) => {
        console.log(resp);
        this.setState({
          secondaryCategories: resp.data.data,
        });
      });
  };

  handleModal = (sec) => {
    console.log(sec);
    this.setState({
      rowId: sec.id,
      visible: true,
    });
  };

  handleDelete = (id) => {
    this.setState({ delLoading: true });
    axios.post(Constants.postUrls.deleteBatchStudents + id).then(() => {
      this.setState({
        notifyDelete: true,
        delLoading: false,
      });
      setTimeout(() => {
        // window.location.reload();
        this.setState({ visible: false }, () => {
          this.getBatchStudents();
        });
      }, 2000);
    });
  };

  openModal() {
    this.setState({
      visibleTestSeries: true,
    });
  }
  closeModal() {
    this.setState({
      visibleTestSeries: false,
    });
  }

  handleTestSeries = (sec) => {
    console.log(sec);
    // return;
    const payload = {
      user_id: sec.user_id,
      ftofbatchid: sec.f_to_f_batch_id,
    };
    axios
      .post(Constants.postUrls.getFtoFAllotNotAllotTest, payload)
      .then((resp) => {
        console.log(resp);
        if (resp.data.status === "success") {
          this.setState(
            {
              allotedTestSeries: resp.data.allotedTitles,
              notallotedTestSeries: resp.data.notAllotedTitles,
              testSeries: [],
              userId: sec.user_id,
              fToFBatchId: sec.f_to_f_batch_id,
            },
            () => {
              this.state.notallotedTestSeries.map((val) => {
                console.log(val);
                this.state.testSeries.push({
                  label: val?.title,
                  value: val?.id,
                });
                this.setState(
                  {
                    testSeries: this.state.testSeries,
                  },
                  () => {
                    console.log(this.state.testSeries);
                  },
                );
              });
            },
          );
        }
      });
    this.openModal();
  };

  saveTestSeries = () => {
    console.log(this.state.userId, this.state.fToFBatchId);
    const payload = {
      user_id: this.state.userId,
      ftofbatchid: this.state.fToFBatchId,
      test_series_id: this.state.test_seriesId,
    };
    axios.post(Constants.postUrls.allotFtoFTestSeries, payload).then((resp) => {
      console.log(resp);
      if (resp.data.status == "success") {
        this.setState(
          {
            notifyTest: true,
            notifyMessage: "Test Series Alloted Successfully.",
          },
          () => {
            setTimeout(() => {
              this.setState({
                visibleTestSeries: false,
                notifyTest: false,
              });
            }, 2000);
          },
        );
      } else {
        this.setState({
          notifyTest: true,
          notifyMessage: "Warning: Allot Test Series To This Batch.",
        });
      }
    });
  };

  openReport = (id) => {
    this.setState({
      rowId: id,
      reportVisible: true,
      notifyDownload: false,
    });
  };

  // Generate + download the batch attendance PDF directly, without navigating
  // the user to the preview page. The pdf-gen service renders the chrome-free
  // "/previewBatchStudents/:id" route in a headless browser and returns a real
  // (editable, vector-text) PDF, which we save straight to disk.
  downloadReportPdf = async (id) => {
    if (!id) return;
    const PDF_SERVICE =
      window.location.hostname === "localhost"
        ? "http://localhost:5000"
        : "https://pdfgen.akclasses.in";

    this.setState({ pdfDownloading: true });
    try {
      const docName = `Batch ${id} Attendance Report.pdf`;
      // Carry the current list filters (search/user_type/attempt_id/status) into
      // the preview page so the generated PDF matches the on-screen, filtered list.
      const filterQuery = this.buildFilterQuery();
      // Carry the Regenerate date range (if one was applied) so the PDF header
      // shows the exact period the report was scoped to. The attendance numbers
      // themselves come from the server's saved (Regenerated) calculation — this
      // only drives the header date label. Both dates persist in state after a
      // successful Regenerate; they're cleared when the date modal is closed.
      const { reportStartDate, reportEndDate } = this.state;
      const dateQuery =
        reportStartDate && reportEndDate
          ? `&start_date=${encodeURIComponent(reportStartDate)}` +
            `&end_date=${encodeURIComponent(reportEndDate)}`
          : "";
      const printPageUrl =
        `${window.location.origin}/previewBatchStudents/${id}` +
        (filterQuery ? `?${filterQuery}` : "?search=") +
        dateQuery;
      const clientUrl = encodeURIComponent(printPageUrl);
      // Pass the admin auth token so the headless browser can seed it into the
      // preview page's localStorage — keeps the PDF working if the report APIs
      // ever start requiring auth (they're public today).
      const authToken = localStorage.getItem("accessToken");
      const pdfUrl =
        `${PDF_SERVICE}/generate-pdf?clientUrl=${clientUrl}` +
        `&appear=${encodeURIComponent("#ak-report-container")}` +
        `&gone=${encodeURIComponent(
          ".loading-screen,.image-loading-placeholder",
        )}` +
        `&format=A4&orientation=portrait` +
        `&name=${encodeURIComponent(docName)}&compression=false` +
        (authToken ? `&token=${encodeURIComponent(authToken)}` : "");

      const res = await fetch(pdfUrl);
      if (!res.ok) {
        console.error("PDF service error:", res.status, await res.text());
        alert(`Failed to generate PDF (${res.status}). Please try again.`);
        return;
      }

      const blob = await res.blob();
      const blobUrl = URL.createObjectURL(blob);
      const a = document.createElement("a");
      a.href = blobUrl;
      a.download = docName;
      a.style.display = "none";
      document.body.appendChild(a);
      a.click();
      setTimeout(() => {
        document.body.removeChild(a);
        URL.revokeObjectURL(blobUrl);
      }, 2000);
    } catch (error) {
      console.error("PDF download error:", error);
      alert("Failed to generate PDF, please try again.");
    } finally {
      this.setState({ pdfDownloading: false });
    }
  };

  handleDownload = async (id) => {
    try {
      this.setState({ downloadLoading: true });

      const response = await axios.get(
        `https://admin.akclasses.in/api/batch-students/pdf?ftof_batch_id=${id}`,
        {
          responseType: "blob",
        },
      );
      console.log("RESPONSE DOWNLOAD REPORT", response);

      const url = window.URL.createObjectURL(new Blob([response.data]));
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", `report_${id}.pdf`);
      document.body.appendChild(link);
      link.click();

      this.setState({
        notifyDownload: true,
        downloadLoading: false,
      });

      setTimeout(() => {
        this.setState({ reportVisible: false });
      }, 2000);
    } catch (err) {
      console.error(err);
      this.setState({ downloadLoading: false });
    }
  };

  render() {
    return (
      <div>
        {this.state.notification ? (
          <Notification
            title={this.state.message}
            type={this.state.type}
            duration={3000}
          />
        ) : null}

        <GridContainer>
          <GridItem xs={12}>
            <Card>
              <CardHeader color="rose" icon>
                <CardIcon color="danger">
                  <Assignment />
                </CardIcon>
                <h4>Simple Table</h4>
              </CardHeader>
              <CardBody>
                <FormControl
                  style={{
                    position: "absolute",
                    right: "3%",
                    width: "85px",
                    top: "-30px",
                  }}
                  className={classes.selectFormControl}
                >
                  <InputLabel
                    htmlFor="simple-select"
                    className={classes.selectLabel}
                  >
                    Per Page
                  </InputLabel>
                  <Select
                    s
                    key={1}
                    MenuProps={{
                      className: classes.selectMenu,
                    }}
                    classes={{
                      select: classes.select,
                    }}
                    value={this.state.per_page}
                    inputProps={{
                      name: "per_page",
                      id: "simple-select",
                      onChange: (e) => {
                        this.handlePage(e);
                      },
                    }}
                  >
                    {perPages.map((v, i) => (
                      <MenuItem
                        key={i}
                        classes={{
                          root: classes.selectMenuItem,
                          selected: classes.selectMenuItemSelected,
                        }}
                        value={v}
                      >
                        {v}
                      </MenuItem>
                    ))}
                  </Select>
                </FormControl>
                <h3>Face to Face Students</h3>
                {/* TOOLBAR — filters (Student Type / Attempt / Status) + search
                    + refresh, all in normal flow so nothing overlaps. Each filter
                    change keeps the others (they combine); blank = "All" (key omitted). */}
                <div
                  style={{
                    display: "flex",
                    gap: "16px",
                    flexWrap: "wrap",
                    alignItems: "flex-end",
                    marginTop: "10px",
                    marginBottom: "10px",
                  }}
                >
                  <div>
                    <label
                      style={{
                        display: "block",
                        fontSize: "12px",
                        color: "#555",
                        marginBottom: "2px",
                      }}
                    >
                      Student Type
                    </label>
                    <select
                      name="user_type"
                      value={this.state.user_type}
                      onChange={this.handleFilterChange}
                      style={{
                        height: "38px",
                        padding: "6px 10px",
                        borderRadius: "4px",
                        border: "1px solid #ccc",
                        minWidth: "150px",
                      }}
                    >
                      <option value="">All Types</option>
                      <option value="premium">Premium</option>
                      <option value="facetoFace">FaceToFace</option>
                    </select>
                  </div>
                  <div>
                    <label
                      style={{
                        display: "block",
                        fontSize: "12px",
                        color: "#555",
                        marginBottom: "2px",
                      }}
                    >
                      Attempt
                    </label>
                    <select
                      name="attempt_id"
                      value={this.state.attempt_id}
                      onChange={this.handleFilterChange}
                      style={{
                        height: "38px",
                        padding: "6px 10px",
                        borderRadius: "4px",
                        border: "1px solid #ccc",
                        minWidth: "170px",
                      }}
                    >
                      <option value="">All Attempts</option>
                      {this.state.attemptsList.map((a) => (
                        <option key={a.id} value={a.id}>
                          {a.title}
                        </option>
                      ))}
                    </select>
                  </div>
                  <div>
                    <label
                      style={{
                        display: "block",
                        fontSize: "12px",
                        color: "#555",
                        marginBottom: "2px",
                      }}
                    >
                      Status
                    </label>
                    <select
                      name="status"
                      value={this.state.status}
                      onChange={this.handleFilterChange}
                      style={{
                        height: "38px",
                        padding: "6px 10px",
                        borderRadius: "4px",
                        border: "1px solid #ccc",
                        minWidth: "130px",
                      }}
                    >
                      <option value="">All Status</option>
                      <option value="ACTIVE">ACTIVE</option>
                      <option value="INACTIVE">INACTIVE</option>
                    </select>
                  </div>
                  <div>
                    <label
                      style={{
                        display: "block",
                        fontSize: "12px",
                        color: "#555",
                        marginBottom: "2px",
                      }}
                    >
                      Performance
                    </label>
                    <select
                      name="performance"
                      value={this.state.performance}
                      onChange={this.handleFilterChange}
                      style={{
                        height: "38px",
                        padding: "6px 10px",
                        borderRadius: "4px",
                        border: "1px solid #ccc",
                        minWidth: "180px",
                      }}
                    >
                      <option value="">All Performance</option>
                      <option value="critical">Critical (below 50%)</option>
                      <option value="improvement">
                        Needs Improvement (50–79%)
                      </option>
                      <option value="excellent">Excellent (80–100%)</option>
                    </select>
                  </div>
                  <div>
                    <label
                      style={{
                        display: "block",
                        fontSize: "12px",
                        color: "#555",
                        marginBottom: "2px",
                      }}
                    >
                      Search Users
                    </label>
                    <input
                      type="text"
                      placeholder="Name / Email / Mobile"
                      value={this.state.search}
                      onChange={(e) =>
                        this.setState({ search: e.target.value })
                      }
                      onKeyDown={(e) => {
                        if (e.key === "Enter") this.searchUser();
                      }}
                      style={{
                        height: "38px",
                        padding: "6px 10px",
                        borderRadius: "4px",
                        border: "1px solid #ccc",
                        minWidth: "230px",
                      }}
                    />
                  </div>
                  <Button onClick={this.searchUser} color="success">
                    Search
                  </Button>
                  <Button onClick={this.clearFilters} color="danger">
                    Clear
                  </Button>
                  <div style={{ marginLeft: "auto" }}>
                    <Button
                      onClick={() => {
                        this.setState({ isReporting: true });
                      }}
                      color="primary"
                    >
                      Refresh Report
                    </Button>
                  </div>
                </div>
              </CardBody>
              <div
                style={
                  {
                    // position: "absolute",
                    // right: "22%",
                    // top: "35px",
                  }
                }
              >
                {/* <Button
                  onClick={() => {
                    this.openReport(this.state.batch_id);
                  }}
                  style={{
                    position: "relative",
                    // bottom: "62px",
                    left: "20px",
                  }}
                  color="warning"
                >
                  Download Report
                </Button> */}
                <Button
                  onClick={() => this.downloadReportPdf(this.state.batch_id)}
                  disabled={this.state.pdfDownloading}
                  style={{
                    position: "relative",
                    // bottom: "62px",
                    left: "20px",
                    backgroundColor: " #4a24a8",
                    opacity: this.state.pdfDownloading ? 0.7 : 1,
                  }}
                >
                  {this.state.pdfDownloading ? "Generating..." : "Download PDF"}
                </Button>
              </div>
              <Table
                tableHead={[
                  "S.no",
                  "Name",
                  "Email",
                  "Mobile No",
                  // "Subject",
                  "Student Type",
                  "Attempt",
                  "Status",
                  // "Details",
                  "Present",
                  "Absent",
                  "Average",
                  "Action",
                ]}
                tableData={this.state.secondaryCategories.map((sec, index) => [
                  [index + 1],
                  [sec?.name],
                  [sec?.email],
                  [sec?.mobile],
                  // [" "],
                  [sec?.user_details?.TYPE],
                  // [sec?.ftof_batches?.batch_name],
                  [sec?.attempt?.title],
                  [
                    <span
                      style={{
                        color:
                          sec?.user_details?.STATUS === "ACTIVE"
                            ? "green"
                            : "red",
                        fontWeight: "500",
                      }}
                    >
                      {sec?.user_details?.STATUS}
                    </span>,
                  ],
                  [
                    <span style={{ fontWeight: "500" }}>
                      {sec?.present_value
                        ? sec.present_value.split(".")[0] + " Days"
                        : ""}
                    </span>,
                  ],
                  [
                    <span style={{ fontWeight: "500" }}>
                      {sec?.absent_value
                        ? sec.absent_value.split(".")[0] + " Days"
                        : ""}
                    </span>,
                  ],
                  [
                    sec?.total_average !== undefined &&
                    sec?.total_average !== null ? (
                      <span
                        style={{
                          color: this.getColor(sec.total_average),
                          fontWeight: "500",
                        }}
                      >
                        {sec.total_average}%
                      </span>
                    ) : (
                      ""
                    ),
                  ],

                  // [
                  //   <div>
                  //     <p>Batch Name: {sec?.ftof_batches?.batch_name} </p>
                  //     <p>Subject Name: {sec?.ftof_subjects?.title}</p>
                  //     <p>User Type: {sec?.user_details?.TYPE} </p>
                  //     <Link
                  //       key={index}
                  //       to={{
                  //         pathname:
                  //           "/admin/viewfaceStudentAttendance/" + sec.id,
                  //         state: { data: sec },
                  //       }}
                  //     >
                  //       <Button className="btn-round" color="info">
                  //         View Attendence
                  //       </Button>
                  //     </Link>
                  //   </div>,
                  // ],
                  [
                    <Link
                      key={index}
                      to={{
                        pathname: "/admin/viewfaceStudentAttendance/" + sec.id,
                        state: { data: sec },
                      }}
                    >
                      <span className="btn text-primary btn-sm">
                        <Assignment />
                      </span>
                    </Link>,
                    // <Button
                    //   className="btn-round"
                    //   style={{
                    //     backgroundColor: "rgb(186, 144, 198)",
                    //   }}
                    //   onClick={() => {
                    //     this.handleTestSeries(sec);
                    //     this.setState({
                    //       visibleTestSeries: true,
                    //     });
                    //   }}
                    // >
                    //   Add Test Series
                    // </Button>,
                    <IconButton
                      aria-label="Delete"
                      className={classes.tableActionButton}
                    >
                      <span
                        class="material-icons"
                        onClick={() => {
                          this.handleModal(sec);
                        }}
                      >
                        delete
                      </span>
                    </IconButton>,
                    // <Button
                    //   className="btn-round"
                    //   style={{
                    //     backgroundColor: "#E21818",
                    //   }}
                    //   onClick={() => {
                    //     this.handleModal(sec);
                    //   }}
                    // >
                    //   Delete
                    // </Button>,
                  ],
                ])}
              />
            </Card>
          </GridItem>
        </GridContainer>
        {this.state.secondaryCategories.length === 0 ? (
          <div>
            <h6 style={{ textAlign: "center" }}>No Data Found</h6>
          </div>
        ) : (
          <div>
            <div style={{ float: "left" }}>
              Showing {this.state.from} to {this.state.to} of {this.state.total}{" "}
              entries.
            </div>
            <div style={{ float: "right", border: "1px solid grey" }}>
              <div
                onClick={this.prevPages}
                style={{
                  width: "34px",
                  textAlign: "center",
                  padding: "4px 0px 4px 0px",
                  backgroundColor: "transparent",
                  fontWeight: "bold",
                  display: "inline-block",
                  cursor: "pointer",
                  color: "grey",
                }}
              >
                <i
                  style={{ fontSize: "16px", position: "relative", top: "3px" }}
                  className="material-icons"
                >
                  &#xe5c4;
                </i>
              </div>
              {this.state.filteredBtnIdArray.map((v, i) => (
                <div
                  key={i}
                  onClick={() => {
                    this.currentPage(v);
                  }}
                  style={{
                    width: "34px",
                    textAlign: "center",
                    borderLeft:
                      (v % 2 === 0 && (i === 1 || i === 2 || i === 3)) ||
                      (v % 2 === 0 && i === 4)
                        ? ""
                        : "1px solid grey",
                    borderRight:
                      (v % 2 === 0 && (i === 1 || i === 2 || i === 3)) ||
                      (v % 2 === 0 && i === 0)
                        ? ""
                        : "1px solid grey",
                    backgroundColor:
                      this.state.active === v ? "skyblue" : "transparent",
                    padding: "5px 0px 5px 0px",
                    fontWeight: this.state.active === v ? "bold" : "",
                    display: "inline-block",
                    cursor: "pointer",
                    color: "black",
                  }}
                >
                  {v}
                </div>
              ))}
              <div
                onClick={this.nextPages}
                style={{
                  width: "34px",
                  borderLeft:
                    this.state.filteredBtnIdArray.length === 2 ||
                    this.state.filteredBtnIdArray.length === 4
                      ? "1px solid grey"
                      : "",
                  padding: "4px 0px 4px 0px",
                  backgroundColor: "transparent",
                  textAlign: "center",
                  fontWeight: "bold",
                  display: "inline-block",
                  cursor: "pointer",
                  color: "grey",
                }}
              >
                <i
                  style={{ fontSize: "16px", position: "relative", top: "3px" }}
                  className="material-icons"
                >
                  &#xe5c8;
                </i>
              </div>
            </div>
          </div>
        )}
        <Modal
          visible={this.state.visible}
          width="600"
          height="100"
          effect="fadeInUp"
          onClickAway={() => this.setState({ visible: false })}
        >
          <GridContainer>
            <GridItem xs={12} sm={12} md={12}>
              <Card>
                <CardBody>
                  <div>
                    <h3>Are You Sure You Want to Delete Record?</h3>
                    {this.state.notifyDelete ? (
                      <div>
                        <span style={{ color: "green" }}>
                          User Deleted Successfuly!
                        </span>
                      </div>
                    ) : null}
                    <GridContainer>
                      <GridItem xs={12} sm={12} md={4}>
                        <br />
                        <Button
                          className=""
                          color="warning"
                          onClick={() => {
                            this.handleDelete(this.state.rowId);
                          }}
                        >
                          {this.state.delLoading ? <Loader /> : "Yes"}
                        </Button>
                        <Button
                          className=""
                          color="danger"
                          onClick={() => {
                            this.setState({ visible: false });
                          }}
                        >
                          No
                        </Button>
                      </GridItem>
                    </GridContainer>
                  </div>
                </CardBody>
              </Card>
            </GridItem>
          </GridContainer>
        </Modal>

        <Modal
          visible={this.state.visibleTestSeries}
          minWidth="3000"
          minHeight="350"
          effect="fadeInRight"
          onClickAway={() => this.closeModal()}
        >
          <GridContainer>
            <GridItem xs={12} sm={12} md={12}>
              <Card>
                <CardBody>
                  <div>
                    {this.state.notifyTest ? (
                      <div>
                        <span
                          style={{
                            color: "red",
                            marginLeft: "22%",
                            fontSize: "16px",
                            fontWeight: 500,
                          }}
                        >
                          {this.state.notifyMessage}
                        </span>
                      </div>
                    ) : null}
                    <h5 style={{ textAlign: "center" }}>
                      Do You Want To Add Test Series For This Order?
                    </h5>
                    {this.state.mailFail ? (
                      <div>
                        <span
                          style={{
                            color: "red",
                            textTransform: "capitalize",
                          }}
                        >
                          {this.state.strMessage}
                        </span>
                      </div>
                    ) : null}
                    {this.state.statLoading ? (
                      <h6 style={{ textAlign: "center" }}>
                        Fetching Test Series Details...
                      </h6>
                    ) : (
                      <div style={{ width: "560px" }}>
                        <label htmlFor="Courses">Test Series</label>
                        <MultiSelect
                          disableSearch
                          options={this.state.testSeries}
                          value={this.state.test}
                          onChange={(data) => {
                            this.setState(
                              {
                                test: data,
                              },
                              () => {
                                this.state.test.map((v) => {
                                  this.state.test_seriesId.push(v.value);
                                });
                                this.setState({
                                  test_seriesId: this.state.test_seriesId,
                                });
                              },
                            );
                          }}
                          labelledBy={"Test Series"}
                        />
                        <h6 style={{ textAlign: "center" }}>
                          Alloted Test Series
                        </h6>
                        <Table
                          tableHead={["Id", "Title"]}
                          tableData={this.state.allotedTestSeries.map((sec) => [
                            [sec.id],
                            [sec.title],
                          ])}
                        />
                        <GridContainer>
                          <GridItem xs={12} sm={12} md={4}>
                            <br />
                            <Button
                              className=""
                              color="warning"
                              onClick={this.saveTestSeries}
                            >
                              {this.state.loading ? <Loader /> : "Yes"}
                            </Button>
                            <Button
                              className=""
                              color="danger"
                              onClick={() => {
                                this.closeModal();
                                this.setState({
                                  visible: false,
                                  showStrategy: false,
                                });
                              }}
                            >
                              No
                            </Button>
                          </GridItem>
                        </GridContainer>
                      </div>
                    )}
                  </div>
                </CardBody>
              </Card>
            </GridItem>
          </GridContainer>
        </Modal>

        <Modal
          visible={this.state.isReporting}
          width="440"
          height="300"
          effect="fadeInUp"
          onClickAway={() => this.onClose()}
        >
          <div style={{ padding: "20px", textAlign: "center" }}>
            <p
              style={{
                marginBottom: "18px",
                fontSize: "16px",
                fontWeight: "500",
              }}
            >
              Are you sure you want to regenerate the report?
            </p>

            {/* Optional date range — leave both empty to use all days. */}
            <div
              style={{
                display: "flex",
                justifyContent: "center",
                gap: "15px",
                marginBottom: "8px",
              }}
            >
              <div style={{ textAlign: "left" }}>
                <label
                  style={{ display: "block", fontSize: "12px", color: "#555" }}
                >
                  Start Date
                </label>
                <input
                  type="date"
                  value={this.state.reportStartDate}
                  max={this.state.reportEndDate || undefined}
                  onChange={(e) =>
                    this.setState({ reportStartDate: e.target.value })
                  }
                  style={{
                    height: "38px",
                    padding: "6px 10px",
                    borderRadius: "4px",
                    border: "1px solid #ccc",
                  }}
                />
              </div>
              <div style={{ textAlign: "left" }}>
                <label
                  style={{ display: "block", fontSize: "12px", color: "#555" }}
                >
                  End Date
                </label>
                <input
                  type="date"
                  value={this.state.reportEndDate}
                  min={this.state.reportStartDate || undefined}
                  onChange={(e) =>
                    this.setState({ reportEndDate: e.target.value })
                  }
                  style={{
                    height: "38px",
                    padding: "6px 10px",
                    borderRadius: "4px",
                    border: "1px solid #ccc",
                  }}
                />
              </div>
            </div>
            <p
              style={{ fontSize: "11px", color: "#999", marginBottom: "20px" }}
            >
              Leave both empty to calculate across all days.
            </p>

            <div
              style={{ display: "flex", justifyContent: "center", gap: "15px" }}
            >
              <button
                onClick={this.onClose}
                style={{
                  padding: "10px 20px",
                  background: "#ccc",
                  border: "none",
                  borderRadius: "5px",
                  cursor: "pointer",
                  fontWeight: "500",
                }}
              >
                Cancel
              </button>

              <button
                onClick={() =>
                  this.setState({ reportStartDate: "", reportEndDate: "" })
                }
                disabled={
                  this.state.isRefreshing ||
                  (!this.state.reportStartDate && !this.state.reportEndDate)
                }
                style={{
                  padding: "10px 20px",
                  background: "#fff",
                  color: "#007bff",
                  border: "1px solid #007bff",
                  borderRadius: "5px",
                  cursor: "pointer",
                  fontWeight: "500",
                  opacity:
                    !this.state.reportStartDate && !this.state.reportEndDate
                      ? 0.5
                      : 1,
                }}
              >
                Clear Dates
              </button>

              <button
                onClick={this.refreshReport}
                disabled={this.state.isRefreshing}
                style={{
                  padding: "10px 20px",
                  background: "#007bff",
                  color: "#fff",
                  border: "none",
                  borderRadius: "5px",
                  cursor: "pointer",
                  opacity: this.state.isRefreshing ? 0.7 : 1,
                  fontWeight: "500",
                }}
              >
                {this.state.isRefreshing ? "Regenerating..." : "Regenerate"}
              </button>
            </div>
          </div>
        </Modal>

        {/* PDF generating modal — shown while the headless PDF is being built. */}
        <Modal
          visible={this.state.pdfDownloading}
          width="430"
          height="240"
          effect="fadeInUp"
          onClickAway={() => {}}
        >
          <div style={{ padding: "32px 26px", textAlign: "center" }}>
            <Loader />
            <h4
              style={{
                marginTop: "18px",
                marginBottom: "8px",
                fontWeight: 600,
                color: "#4a24a8",
              }}
            >
              Generating your report…
            </h4>
            <p style={{ color: "#666", fontSize: "14px", lineHeight: 1.6 }}>
              Please wait, this may take some time.
              <br />
              Thank you for your patience.
            </p>
          </div>
        </Modal>

        {/* download report modal  */}
        <Modal
          visible={this.state.reportVisible}
          width="600"
          height="100"
          effect="fadeInUp"
          onClickAway={() => this.setState({ reportVisible: false })}
        >
          <GridContainer>
            <GridItem xs={12} sm={12} md={12}>
              <Card>
                <CardBody>
                  <div>
                    <h3>Do you want to download the report?</h3>

                    {this.state.notifyDownload && (
                      <span style={{ color: "green" }}>
                        Report Downloaded Successfully!
                      </span>
                    )}

                    <GridContainer>
                      <GridItem xs={12} sm={12} md={4}>
                        <br />

                        <Button
                          color="warning"
                          onClick={() =>
                            this.handleDownload(this.state.batch_id)
                          }
                        >
                          {this.state.downloadLoading ? <Loader /> : "Yes"}
                        </Button>

                        <Button
                          color="danger"
                          onClick={() =>
                            this.setState({ reportVisible: false })
                          }
                        >
                          No
                        </Button>
                      </GridItem>
                    </GridContainer>
                  </div>
                </CardBody>
              </Card>
            </GridItem>
          </GridContainer>
        </Modal>
      </div>
    );
  }
}
